<template>  
  <myHeader /> 
  <warheadSection v-on:click_checkbox = "click_checkbox" 
                  v-on:check_all_thing = "check_all_thing" 
                  v-bind:warheadData="warheadData" 
                  v-bind:section_warhead_visible = "section_warhead_visible"
                  SecTitle="residues"  />
   
  <residueSection v-on:click_checkbox = "click_checkbox" 
                  v-on:check_all_thing = "check_all_thing" 
                  v-bind:residueData = "residueData" 
                  v-bind:section_residue_visible = "section_residue_visible"
                  SecTitle="binders" /> 
 
  <binderSection  v-on:click_checkbox = "click_checkbox" 
                  v-on:check_all_thing = "check_all_thing" 
                  v-bind:binderData="binderData" 
                  v-bind:section_binder_visible = "section_binder_visible"
                  SecTitle="records"  /> 
 
  <recordList     v-on:click_checkbox = "click_checkbox"  
                  v-bind:recordData="recordData" 
                  v-bind:section_record_visible = "section_record_visible" />
</template>

 
<script>
import          axios from 'axios';
import residueSection from '@/components/explore/residueSection.vue'
import warheadSection from '@/components/explore/warheadSection.vue'
import  binderSection from '@/components/explore/binderSection.vue'
import     recordList from '@/components/explore/recordList.vue'
import       myHeader from '@/components/header.vue' ;

export default {
  name: 'App', 
  data () {
    return {   
      residueData: {},
      warheadData: {},
      binderData : {},
      recordData : {},
      section_warhead_visible: true,
      section_residue_visible: false,
      section_binder_visible: false,
      section_record_visible: false,
      section_residue_all_checked: false,
      section_warhead_all_checked: false,
      section_binder_all_checked: false,
    }
  }, 
  components: {
    recordList, binderSection, warheadSection, residueSection, myHeader
  },  

  mounted () { 
    axios.get('warhead_warheads')
         .then(response => {
           this.warheadData=response.data;
         });
  }, 

  methods: {
    checked_sth: function (name) {
      var y = [];
      var x = document.getElementsByName(name); 
      for (var i = 0; i < x.length; i++)
        if (x[i].checked == true)
          y.push(x[i].value);  
      // console.log(name, ':', y);
      return y;
    }, 

    check_all_thing: function (boxName) {  
      if        (boxName=="checkbox_residue") {
        this.section_residue_all_checked  = !this.section_residue_all_checked  ;
        var flag = this.section_residue_all_checked ;  
      } else if (boxName=="checkbox_warhead") {
        this.section_warhead_all_checked = !this.section_warhead_all_checked ;
        flag = this.section_warhead_all_checked ; 
      } else if (boxName=="checkbox_binder") {
        this.section_binder_all_checked  = !this.section_binder_all_checked  ;
        flag = this.section_binder_all_checked ; 
      }

      var x = document.getElementsByName(boxName);  
      for (var i = 0; i < x.length; i++)
        x[i].checked = flag; 
      this.click_checkbox(boxName);

    }, 

    click_checkbox: function (boxName) { 
      if (boxName=='checkbox_warhead') { 
        // residues = this.checked_sth("checkbox_residue");
        var warheads = this.checked_sth(boxName);
        if (warheads.length > 0) {
          axios.post('warhead_residues', 
                 {'warheads':warheads})
               .then(response => {  
                 this.residueData=response.data;  
                 this.section_residue_visible = true;
               }); 
        } else { 
          this.residueData={}; 
          this.section_residue_visible = false;
          this.binderData ={}; 
          this.section_binder_visible  = false;
          this.recordData ={}; 
          this.section_record_visible  = false; 
        } 
      } else if (boxName=='checkbox_residue') {
        var residues = this.checked_sth(boxName);
        warheads     = this.checked_sth('checkbox_warhead');
        if (residues.length > 0) {
          axios.post('residue_binders', 
                 {'residues':residues,
                  'warheads':warheads})
               .then(response => {  
                 this.binderData=response.data;   
                 this.section_binder_visible = true;
               }); 
        } else { 
          this.binderData={}; 
          this.section_binder_visible = false;
          this.recordData={}; 
          this.section_record_visible = false; 
          }
      } else if (boxName=='checkbox_binder') {
        var binders = this.checked_sth(boxName);
        residues    = this.checked_sth("checkbox_residue"); 
        if (binders.length > 0) { 
          axios.post('residue_records', 
                 {'residues':residues,
                  'binders':binders})
               .then(response => {
                 this.recordData=response.data;  
                 this.section_record_visible = true;
               }); 
        } else { 
          this.recordData={}; 
          this.section_record_visible = false;
        } 
      } else if (boxName=='download') {
        residues = this.checked_sth("checkbox_residue"); 
        binders = this.checked_sth("checkbox_binder");
        if (binders.length > 0) {  

          var form = document.createElement('form'); 
          form.setAttribute('method', 'post'); 
          form.setAttribute('action', 'residue_download');
          form.setAttribute(    'id', 'residue_download_id'); 
          form.style.display = 'none';

          var inp = document.createElement('input'); 
          inp.setAttribute('type', 'text');
          inp.setAttribute('name', 'foo');
          inp.setAttribute('value', JSON.stringify({'residues': residues, 'binders' : binders}));

          form.appendChild(inp);  
          document.body.appendChild(form); 
          document.getElementById("residue_download_id").submit(); 
          document.body.removeChild(form);  
 
        } else { 
          this.recordData={}; 
          this.section_record_visible = false;
        } 

      }
    },
  }
}
</script>


<style scoped>  
</style> 